// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  NgZone,
  OnDestroy, OnInit,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { SohoContextMenuDirective } from 'ids-enterprise-ng';

@Component({
  selector:    '[ lm-scan-options ]', // tslint:disable-line
  standalone: false,
  templateUrl: './lm-scan-options.component.html',
  styleUrls:   [ 'lm-scan-options.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMScanOptionsComponent implements OnDestroy, OnInit {

  @ViewChild(SohoContextMenuDirective) contextmenu: SohoContextMenuDirective;
  @ViewChild('ScanOptionsButton', {read: ElementRef}) scanOptionsButton: ElementRef;

  @Input() ajaxCallbackFunction: SohoPopupMenuSourceFunction;
  @Input() contextMenuEventFunction: Function;
  @Input() hasContextMenu: boolean;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;
  @Input() dataEntryMode = false;
  @Input() isMemberField = false;
  @Input() isCheckBoxField = true;
  @Input() buttonId: string;
  @Input() scanOptionsLabel: string;
  @Input() isInAccessibilityMode: boolean;
  @Input() displayScanOptions = false;

  public showScanOptions = false;
  private scanOptionsClicked = false;

  @HostBinding('style.position') hostPosition = 'relative';

  @HostBinding('style.display') hostDisplay = '';

  private destroy$ = new Subject<void>();

  constructor(
    private el: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private zone: NgZone) {
    const element = el.nativeElement;
    const mouseEnter$ = fromEvent(element, 'mouseenter', {passive: true});
    const mouseLeave$ = fromEvent(element, 'mouseleave', {passive: true});

    mouseEnter$.pipe(
      tap(() => {
        this.showScanOptions = true;
        this.changeDetectorRef.markForCheck();
      }),
      takeUntil(this.destroy$)
    ).subscribe();

    mouseLeave$.pipe(
      tap(() => {
        if (this.scanOptionsClicked) {
          // if the field options has been clicked, leave the button visible for a bit
          this.zone.runOutsideAngular(() => {
            setTimeout(() => {
              this.showScanOptions = false;
              this.scanOptionsClicked = false;
              this.changeDetectorRef.markForCheck();
            }, 100);
          });
        } else {
          this.showScanOptions = false;
          this.changeDetectorRef.markForCheck();
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  public ngOnInit() {
    // If a single textarea in a paragraph layout
    // Allow textarea to display block so it will span 100% width
    if ((this.lmParagraphLayoutInfo?.textAreaOnly) || this.isCheckBoxField) {
      this.hostDisplay = '';
    } else {
      this.hostDisplay = 'inline-flex';
    }
  }

  public ngOnDestroy() {
    this.destroy$.next();
  }
  handleFocus() {
    if (this.scanOptionsButton?.nativeElement) {
      this.scanOptionsButton.nativeElement.classList.remove('hide-focus');
    }
  }

  public openScanOptions(event: Event) {
    if (event) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
    this.scanOptionsClicked = true;
    this.showScanOptions = true;
    this.contextmenu.initializeComponent();
  }

  public focusToScanOptionsButton() {
    this.showScanOptions = true;
    this.scanOptionsClicked = false;
    if (this.scanOptionsButton?.nativeElement) {
      this.scanOptionsButton.nativeElement.focus();
    }
  }

  handleBlur() {
    if (!this.scanOptionsClicked) {
      this.showScanOptions = false;
    }
  }
}
